module.exports = __webpack_public_path__ + "static/media/instagram_cinza.75e70aee.svg";